import { createFileRoute, redirect } from '@tanstack/react-router'
import { getDefaultStore } from 'jotai'
import { Shell } from '@/components/layout/Shell'
import { isAuthenticatedAtom, sessionAtom, waitForAuthInit } from '@/store/auth.atom'

export const Route = createFileRoute('/_private')({
  beforeLoad: async ({ location }) => {
    if (typeof window === 'undefined') return

    await waitForAuthInit()

    const store = getDefaultStore()
    const isAuthenticated = store.get(isAuthenticatedAtom)

    if (!isAuthenticated) {
      throw redirect({
        to: '/login',
        search: { redirect: location.href },
      })
    }
    const session = store.get(sessionAtom)
    const loginCount = session?.user.loginCount
    if (loginCount === 0) {
      throw redirect({ to: '/password' })
    }


  },
  component: PrivateLayout,
})

function PrivateLayout() {
  return <Shell />
}
